var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0306 11.9694C13.1715 12.1103 13.2506 12.3014 13.2506 12.5006C13.2506 12.6999 13.1715 12.891 13.0306 13.0319C12.8897 13.1728 12.6986 13.2519 12.4993 13.2519C12.3001 13.2519 12.109 13.1728 11.9681 13.0319L7.99997 9.0625L4.0306 13.0306C3.8897 13.1715 3.69861 13.2507 3.49935 13.2507C3.30009 13.2507 3.10899 13.1715 2.9681 13.0306C2.8272 12.8897 2.74805 12.6986 2.74805 12.4994C2.74805 12.3001 2.8272 12.109 2.9681 11.9681L6.93747 8L2.96935 4.03062C2.82845 3.88973 2.7493 3.69863 2.7493 3.49937C2.7493 3.30012 2.82845 3.10902 2.96935 2.96812C3.11024 2.82723 3.30134 2.74807 3.5006 2.74807C3.69986 2.74807 3.89095 2.82723 4.03185 2.96812L7.99997 6.9375L11.9693 2.9675C12.1102 2.8266 12.3013 2.74745 12.5006 2.74745C12.6999 2.74745 12.891 2.8266 13.0318 2.9675C13.1727 3.1084 13.2519 3.29949 13.2519 3.49875C13.2519 3.69801 13.1727 3.8891 13.0318 4.03L9.06247 8L13.0306 11.9694Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.66f31c5d8060638ce3c57ee896748398.svg";
export { ForwardRef as ReactComponent };